




























































import * as api from '@/api';
import Vue from 'vue';
import moment from 'moment';

export default Vue.extend({
    data() {
        return {
            dataLoading: true,
            news: [] as api.NewsItem[],
            activeIndex: '',
            filters: [
                {
                    value: '',
                    name: '全部',
                },
                {
                    value: 1,
                    name: '产品更新',
                },
                {
                    name: '系统公告',
                    value: 0,
                },
            ],
            scrollListener: null as any,
        };
    },
    filters: {
        timeFormat(val) {
            return moment(val).format('YYYY年MM月DD日 HH:mm');
        },
    },
    mounted() {
        this.$store.dispatch('getUnreadCount');
        this.getSitMessages();
        let timer: number; // 节流
        this.scrollListener = () => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                const rect = (this.$refs.container as Element).getClientRects()[0];
                // viewportHeight的计算逻辑是网上复制来的
                const viewportHeight = window.innerHeight
                    || document.documentElement.clientHeight
                    || document.body.clientHeight || 0;
                if (rect.height + rect.y - viewportHeight <= 10) { // 10 pixcel就触发
                    this.getSitMessages();
                }
            }, 200);
        };
        window.addEventListener('scroll', this.scrollListener);
    },
    computed: {
        unreadCount(): number {
            return this.$store.state.unreadCount;
        },
        lookNewsId(): string {
            return this.$store.state.lookNewsId;
        },
    },
    watch: {
        lookNewsId(id) {
          const idx = this.news.findIndex((i) => i.id === id);
          this.news[idx].change = true;
        },
    },
    methods: {
        readAll() {
            if (this.unreadCount) {
                this.news = [];
                api.readMessagesAll().then((res) => {
                    if (!api.error(res)) {
                        this.getSitMessages();
                        this.$store.dispatch('getUnreadCount');
                    }
                });
            }
        },
        async readNew(item) {
            if (!item.isReaded) {
                const res = await api.readMessages({ id: item.id });
                if (!api.error(res)) {
                    this.getSitMessages();
                    this.$store.dispatch('getUnreadCount');
                }
            }
            // this.$store.commit('currentProductInfo', { ...item.extData, ...{ name: item.title.split('已更新')[0] } });
            const path = `/product/${item.extData.productId}`;
            const { href } = this.$router.resolve({
                path,
            });
            window.open(href, '_blank');
        },
        async lookOver(item) {
            if (!item.category) { // 如果是系统消息
                if (item.breviary.length > 50) {
                    item.change = !item.change;
                }
                if (item.isReaded) return;
                const res = await api.readMessages({ id: item.id });
                if (!api.error(res)) {
                    item.isReaded = true;
                    this.$store.dispatch('getUnreadCount');
                }
            }
        },
        filterNews(item) {
            this.news = [];
            this.activeIndex = item.value;
            this.getSitMessages();
        },
        async getSitMessages() {
            this.dataLoading = true;
            const res = await api.getSitMessages({
                Status: null,
                SkipCount: this.news.length,
                MaxResultCount: 10,
                Category: this.activeIndex,
            });
            if (!api.error(res)) {
                if (res.data.items.length === 0) {
                    window.removeEventListener('scroll', this.scrollListener);
                    this.dataLoading = false;
                    return;
                }
                res.data.items.forEach((e) => {
                    if (e.content) {
                        e.breviary = e.content.replace(/<img[^>]+>/g, '*[图片]*').replace(/<[^>]+>/g, '');
                        if (e.breviary.length > 50) {
                            e.breviary = `${e.breviary.slice(0, 50)}...`;
                        }
                    }
                    e.change = e.id === this.lookNewsId; // 从弹窗那点过来就自动打开
                });
                this.news = [...this.news, ...res.data.items];
            }
            this.dataLoading = false;
        },
    },
     destroyed() {
        window.removeEventListener('scroll', this.scrollListener);
    },
});
